// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBrH8Eu2_ui_oNewz0GNMvbnj8hscH_6jE",
  authDomain: "wishist-31c1a.firebaseapp.com",
  projectId: "wishist-31c1a",
  storageBucket: "wishist-31c1a.appspot.com",
  messagingSenderId: "1016306163843",
  appId: "1:1016306163843:web:00217757251a755d81fbb6",
  measurementId: "G-V496VPXF04"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = process.env.NODE_ENV === 'production' ? getAnalytics(app) : null;
const auth = getAuth(app);
const storage = getStorage();

export { db, analytics, auth, storage };
